// extracted by mini-css-extract-plugin
export default {"no-result":"OutsourcedWorkSelector_no-result_XSeDJ","reference":"OutsourcedWorkSelector_reference_khQRa","contractor":"OutsourcedWorkSelector_contractor_EHWzJ"};